module.exports = __webpack_public_path__ + "assets/images/b_g.46b0617f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/b_g.png
// module id = 372
// module chunks = 1